<div class="page-container">
  <div class="page-header">
    <h1>Gestion des produits</h1>
    <p>Liste de tous les produits disponibles</p>
  </div>

  @if (isLoading) {
    <div class="loading">
      Chargement des produits...
    </div>
  }

  @if (!isLoading) {
    <div class="search-container">
      <div class="search-box">
        <i class="pi pi-search search-icon"></i>
        <input
          type="text"
          class="search-input"
          placeholder="Rechercher un produit (titre, PLU, famille...)"
          [(ngModel)]="searchText"
          (input)="onSearch()"
        />
        @if (searchText) {
          <i class="pi pi-times clear-icon" (click)="searchText = ''; onSearch()"></i>
        }
      </div>

      <button
        class="btn-print"
        (click)="printSelection()"
        [disabled]="isLoading"
        title="Imprimer la sélection"
      >
        <i class="pi pi-print"></i>
        <span>Imprimer</span>
      </button>
    </div>

    @if (selectedProducts.length > 0) {
      <div class="selection-bar">
        <div class="selection-info">
          <i class="pi pi-check-circle"></i>
          <span>{{ selectedProducts.length }} produit(s) sélectionné(s)</span>
        </div>
        <button class="btn-action" (click)="mettreADisposition()">
          <i class="pi pi-plus-circle"></i>
          Mettre à disposition
        </button>
      </div>
    }

    <div class="print-header" style="display: none;">
      <h1 class="print-title">Liste des produits</h1>
      <p class="print-subtitle">
        {{ selectedProducts.length > 0 ? selectedProducts.length + ' produit(s) sélectionné(s)' : 'Tous les produits (' + produits.length + ')' }}
      </p>
      <p class="print-date">Imprimé le {{ currentDate | date:'dd MMMM yyyy à HH:mm':'fr-FR' }}</p>
    </div>

    <div class="grid-container">
      <ag-grid-angular
        class="ag-theme-balham"
        [rowData]="produits"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [rowSelection]="rowSelection"
        [theme]="theme"
        [pagination]="true"
        [paginationPageSize]="paginationPageSize"
        [paginationPageSizeSelector]="paginationPageSizeSelector"
        [domLayout]="'autoHeight'"
        (gridReady)="onGridReady($event)"
        (selectionChanged)="onSelectionChanged($event)"
      >
      </ag-grid-angular>
    </div>
  }

  @if (showQuantityDialog) {
    <div class="quantity-dialog-overlay" (click)="cancelDialog()">
      <div class="quantity-dialog" (click)="$event.stopPropagation()">
        <div class="dialog-header">
          <h2>Mise à disposition</h2>
          <p>Saisissez les quantités pour chaque produit</p>
        </div>

        @if (isSuperAdmin && !magasinSimulation.isSimulating()) {
          <div class="magasin-selection">
            <label for="magasin-select">Magasin :</label>
            <select
              id="magasin-select"
              [value]="selectedMagasinId || ''"
              (change)="onMagasinChange($any($event.target).value)"
              class="magasin-select"
            >
              <option value="">-- Sélectionner un magasin --</option>
              @for (user of magasinsUsers; track user.id) {
                <option [value]="getMagasinId(user)">
                  {{ user.nom || (user.prenom + ' ' + user.nom) }} - Magasin {{ getMagasinId(user) }}
                </option>
              }
            </select>
          </div>
        }

        <div class="product-list">
          @for (produit of selectedProducts; track produit.plu) {
            <div class="product-item">
              <div class="product-info">
                <p class="product-title">{{ getProductDisplayName(produit) }}</p>
                <p class="product-plu">PLU: {{ produit.plu }}</p>
              </div>
              <div class="quantity-input">
                <label>Quantité:</label>
                <input
                  type="number"
                  min="1"
                  [value]="productQuantities.get(getPluAsNumber(produit.plu)) || 1"
                  (input)="updateQuantity(getPluAsNumber(produit.plu), $any($event.target).value)"
                />
              </div>
            </div>
          }
        </div>

        <div class="dialog-actions">
          <button class="btn-cancel" (click)="cancelDialog()">Annuler</button>
          <button class="btn-confirm" (click)="confirmMiseADisposition()">Valider</button>
        </div>
      </div>
    </div>
  }
</div>
